import { Component } from 'react';
import UITag from 'UIComponents/tag/UITag';
import SyntheticEvent from 'UIComponents/core/SyntheticEvent';
import { jsx as _jsx } from "react/jsx-runtime";
// copied from UIComponents MultiSelectValue.js
// https://git.hubteam.com/HubSpot/UIComponents/blob/master/UIComponents/static-3.6077/js/input/utils/MultiSelectValue.js
export default class MultiSelectValue extends Component {
  constructor(...args) {
    super(...args);
    this.handleMouseDown = evt => {
      const {
        onClick,
        value
      } = this.props;
      if (evt.type === 'mousedown' && evt.button !== 0) {
        return;
      }
      if (onClick) {
        evt.stopPropagation();
        onClick(SyntheticEvent(value));
      }
    };
    this.handleCloseMouseDown = evt => {
      const {
        onRemove,
        value
      } = this.props;
      onRemove(value);

      // Prevent input focus, which leads to scroll jank (#1724)
      evt.preventDefault();
      evt.stopPropagation();
    };
  }
  render() {
    const {
      children,
      className,
      closeable,
      style,
      value
    } = this.props;
    const computedUse = value.tagUse || 'default';
    return /*#__PURE__*/_jsx(UITag
    //@ts-expect-error This prop isn't on the TS declaration for UITag
    , {
      _bordered: true,
      _onCloseMouseDown: this.handleCloseMouseDown,
      className: className,
      closeable: closeable,
      onMouseDown: this.handleMouseDown,
      onTouchEnd: this.handleMouseDown,
      style: style,
      use: computedUse,
      children: children
    });
  }
}
MultiSelectValue.displayName = 'MultiSelectValue';